import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import {Table, Icon} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {shortDate, fullDate} from '../../../common/constants/datesFormat';
import {dealerOrdersStatus as status} from '../../../common/dictionaries/classification';
import {getOrderStatusName, getOrderTypeName, transportOptions} from '../common/utils';
import {SPECIAL_TYPE} from '../../constants';
import DeleteIcon from '../common/deleteIcon';
import PartInfo from '../common/partInfo';

class OrderInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'showBilling': false,
      'showSubstitutes': false,
    };
    this.handleShowIconClick = this.handleShowIconClick.bind(this);
    this.handleShowClick = this.handleShowClick.bind(this);
    this.handleShowSubstitutesClick = this.handleShowSubstitutesClick.bind(this);
    this.renderLoading = this.renderLoading.bind(this);
    this.renderEtaUpdated = this.renderEtaUpdated.bind(this);
    this.renderEtaStandard = this.renderEtaStandard.bind(this);
  }

  handleShowIconClick() {
    this.setState({'showBilling': !this.state.showBilling});
  }

  handleShowSubstitutesClick() {
    this.setState({'showSubstitutes': !this.state.showSubstitutes});
  }

  handleShowClick() {
    const {order} = this.props;
    this.props.selectOrderForTrackingSchedule(order.orderSequence);
  }

  getDisabledStatus() {
    const {order, user} = this.props;
    const disabledStatus = [status.rejected, status.labeled, status.billed];

    if (order.user && order.user.toUpperCase() !== user.toUpperCase()) {
      return true;
    }

    if (order.orderType === SPECIAL_TYPE) {
      return [...disabledStatus, status.processed, status.denied, status.removed, status.inTransit].includes(
        order.status
      );
    }

    return disabledStatus.includes(order.status);
  }

  renderAttendedQuantity(value) {
    if (!value) {
      return 0;
    }

    return value;
  }

  renderBillingIcon() {
    const {order} = this.props;
    const {orderDetail} = order;

    if (!orderDetail.length || order.status === status.billed) {
      return null;
    }

    const iconName = this.state.showBilling ?
      'minus circle' :
      'plus circle';

    return <Icon link size='large' color='blue' name={iconName} onClick={this.handleShowIconClick} />;
  }

  renderSubstituteIcon() {
    const {order} = this.props;

    if (!order.substitutedOrders || !order.substitutedOrders.length) {
      return null;
    }

    const iconName = this.state.showSubstitutes ? 'minus circle' : 'plus circle';

    return (
      <Icon
        link
        size='small'
        color='orange'
        name={iconName}
        title='Ver códigos sustituidos'
        style={{'verticalAlign': 'middle', 'marginLeft': '6px'}}
        onClick={this.handleShowSubstitutesClick}
      />
    );
  }

  renderBillingDetail(order) {
    if (!this.state.showBilling || !order.orderDetail.length) {
      return null;
    }

    return (
      <Table.Row>
        <Table.Cell colSpan='100%'>
          <Table className='invoice-table'>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Reserva</Table.HeaderCell>
                <Table.HeaderCell>ETA Estándar</Table.HeaderCell>
                <Table.HeaderCell>ETA Actualizada</Table.HeaderCell>
                <Table.HeaderCell>Factura de Importación</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>{this.renderReception(order)}</Table.Body>
          </Table>
        </Table.Cell>
      </Table.Row>
    );
  }

  renderSubstituteDetail() {
    const {order} = this.props;

    if (!this.state.showSubstitutes || !order.substitutedOrders || !order.substitutedOrders.length) {
      return null;
    }

    const sub = order.substitutedOrders[0];

    return (
      <Table.Row>
        <Table.Cell colSpan='100%'>
          <Table className='invoice-table'>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Código Inicial</Table.HeaderCell>
                <Table.HeaderCell>Código Final</Table.HeaderCell>
                <Table.HeaderCell>Estado</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              <Table.Row>
                <Table.Cell>{sub.partCode}</Table.Cell>
                <Table.Cell>{sub.substituteCode}</Table.Cell>
                <Table.Cell>PROCESADO POR SUSTITUTO</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Table.Cell>
      </Table.Row>
    );
  }

  renderReception(order) {
    const {orderDetail = []} = order;

    return orderDetail.map((detail, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell>{detail.reserveQuantity}</Table.Cell>
          <Table.Cell>{this.renderArriveDate(detail.arrivalDate)}</Table.Cell>
          <Table.Cell>{this.renderArriveDate(detail.etdDate)}</Table.Cell>
          <Table.Cell>{detail.billOrder}</Table.Cell>
        </Table.Row>
      );
    });
  }

  renderArriveDate(value) {
    if (!value) {
      return null;
    }

    return moment(value).format(shortDate);
  }

  renderTrackingIcon(order) {
    if (order.orderType !== SPECIAL_TYPE || order.status === status.entered || order.status === status.denied) {
      return null;
    }

    return <Icon link size='large' color='blue' name='history' onClick={this.handleShowClick} />;
  }

  renderLoading() {
    return (
      <div style={{'display': 'flex', 'justifyContent': 'center', 'alignItems': 'center'}}>
        <Icon loading name='spinner' size='large' color='grey' />
      </div>
    );
  }

  renderEtaUpdated(order) {
    if (order.etaUpdated) {
      return moment(order.etaUpdated).format(shortDate);
    }

    return null;
  }

  renderEtaStandard(order) {
    if (order.etaStandard) {
      return moment(order.etaStandard).format(shortDate);
    }

    const obs = order.observations ? order.observations.toLowerCase() : '';

    if (obs.includes('calculando eta')) {
      return this.renderLoading();
    }

    return null;
  }

  render() {
    const {order} = this.props;

    return (
      <Fragment>
        <Table.Row negative={!order.etaStandard}>
          <Table.Cell>{order.orderCode}</Table.Cell>
          <Table.Cell>{getOrderTypeName(order.orderType)}</Table.Cell>
          <Table.Cell style={{'whiteSpace': 'nowrap'}}>
            <PartInfo partCode={order.partCode} partName={order.partName} />
            {this.renderSubstituteIcon()}
          </Table.Cell>
          <Table.Cell textAlign='right'>{order.partQuantity}</Table.Cell>
          <Table.Cell textAlign='right'>
            {this.renderBillingIcon()}
            {this.renderAttendedQuantity(order.attendedQuantity)}
          </Table.Cell>
          <Table.Cell>{moment(order.date).format(fullDate)}</Table.Cell>
          <Table.Cell>{transportOptions[order.dealerTransport]}</Table.Cell>
          <Table.Cell>{getOrderStatusName(order.status)}</Table.Cell>
          <Table.Cell>
            {order.user ?
              order.user.toUpperCase() :
              ''}
          </Table.Cell>
          <Table.Cell>{order.reference}</Table.Cell>
          <Table.Cell>
            {this.renderEtaStandard(order)}
          </Table.Cell>
          <Table.Cell>
            {this.renderEtaUpdated(order)}
          </Table.Cell>
          <Table.Cell>{order.orderRepair}</Table.Cell>
          <Table.Cell>
            {order.billDate ?
              moment(order.billDate).format(fullDate) :
              null}
          </Table.Cell>
          <Table.Cell>{order.comment}</Table.Cell>
          <Table.Cell>{order.observations}</Table.Cell>
          <Table.Cell textAlign='center'>
            {this.renderTrackingIcon(order)}
            <DeleteIcon iconName='delete' order={order} disabled={this.getDisabledStatus()} />
          </Table.Cell>
        </Table.Row>
        {this.renderBillingDetail(order)}
        {this.renderSubstituteDetail()}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'user': state.session.user || '',
  };
};

const {selectOrderForTrackingSchedule} = Actions;

export default connect(mapStateToProps, {
  selectOrderForTrackingSchedule,
})(OrderInfo);
